import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  NumberIncrementStepper,
  NumberInputStepper,
  NumberInputField,
  NumberInput,
  Box,
  FormLabel,
  NumberDecrementStepper,
  useDisclosure
} from '@chakra-ui/react'
import { FC, useState } from 'react'

import useMrpReab from '@hook/mrp/use-reab'
import useTools from '@hook/shared/use-tools'

import Filter from '@component/Shared/Filter'

import { ILayoutActionSuppliers } from '@base/@types/components/Layout/Tools'

import LayoutToolsButton from '../Components/Button'

const ActionPurchaseCreateOrderSapReab: FC<ILayoutActionSuppliers> = ({
  data,
  onUpdate,
  isScheduled = false
}) => {
  const {
    handleUpdateSapParams,
    paramsSap,
    exportDataSap,
    supplyMethod,
    discountSupply
  } = useMrpReab()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { isDisabled } = useTools()
  const [loading, setLoading] = useState(false)
  const [valueDesconto, setDesconto] = useState('')
  const unique = [
    ...new Set(
      data.map(item => item.estoque?.produtoFornecedor?.fornecedor?.codigo)
    )
  ]

  const validateSap = () => {
    if (
      discountSupply.metodoPagamentoId === paramsSap.metodoPagamento[0]?.value
    ) {
      if (valueDesconto < discountSupply.desconto) {
        setDesconto(discountSupply.desconto.toString())
      }
    }
  }
  const defaultDiscount = (value: any) => {
    if (discountSupply.metodoPagamentoId === value[0]?.value) {
      setDesconto(discountSupply.desconto.toString())
    }
  }

  return (
    <>
      <LayoutToolsButton label="Criar Pedido" onClick={exportDataSap} />
      <Modal isOpen={isOpen} onClose={onClose} size="sm">
        <ModalOverlay />
        <ModalContent transition="all ease .3s">
          <ModalHeader
            bgColor="white"
            display="flex"
            alignItems="center"
            gap={2}
          >
            Criar Pedido{' '}
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody bgColor="white">
            <Box w="100%">
              <FormControl id="discount">
                <FormLabel>Desconto </FormLabel>
                <NumberInput
                  borderColor="blackAlpha.400"
                  value={valueDesconto}
                  onChange={value => setDesconto(value)}
                  onBlur={(event: any) => {
                    validateSap()
                    handleUpdateSapParams({
                      name: 'desconto',
                      value: event.target.value
                    })
                  }}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>
            </Box>
            <br></br>
            <Filter
              label="Forma de Pagamento"
              options={supplyMethod.map(paymentMethod => ({
                label: `${paymentMethod.codigo} - ${paymentMethod.descricao}`,
                value: paymentMethod.id
              }))}
              value={paramsSap.metodoPagamento}
              isMulti
              onChange={value => {
                defaultDiscount(value)
                handleUpdateSapParams({ name: 'metodoPagamento', value })
              }}
            />
          </ModalBody>
          <ModalFooter bgColor="white">
            <Button
              variant="ghost"
              color="black"
              onClick={() => {
                exportDataSap()
                onClose()
              }}
              isDisabled={!supplyMethod}
            >
              Criar Pedido
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ActionPurchaseCreateOrderSapReab
